<div class="d-flex flex-row align-items-center mb-3 ml-3 mr-3">
  <div class="h3">{{'navigation_orders' | i18next}}</div>
</div>

<div class="row">
  <div class="col">
    <ul class="nav link-navigation">
      @if (isAdmin) {
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/orders/drafts">{{'navigation_drafts' | i18next}}</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/orders/quotations">{{'navigation_quotations' | i18next}}</a>
        </li>
        <li class="nav-item ml-2" routerLinkActive="active">
          <a class="nav-link" routerLink="/orders/orders">{{'navigation_orders' | i18next}}</a>
        </li>
      }
      <li class="nav-item ml-2" routerLinkActive="active">
        <a class="nav-link" routerLink="/orders/invoices">{{'navigation_invoices' | i18next}}</a>
      </li>
    </ul>
  </div>
</div>

@if (isDrafts) {
  <app-order-draft></app-order-draft>
}
@if (isOrders) {
  <app-order-orders [state]="state"></app-order-orders>
}
@if (isInvoices) {
  <app-order-invoices></app-order-invoices>
}
